export const ACCOUNT_BALANCE = 'ACCOUNT_BALANCE';
export const TRANSACTION_HISTORY = 'TRANSACTION_HISTORY';
export const TOS_READ = 'TOS_READ';
export const TOS_READ_AGREE = 'TOS_READ_AGREE';
